import React from "react";
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import closeButton from "../../shared/img/close-button.svg";

const ModalComponent = ({
    handleCloseModal, 
    modalIsOpen, 
    className, 
    modalData, 
    hideModal
}) => {
    return (
        <Modal
            isOpen={modalIsOpen}
            className={'innlink-modal ' + className}
            onRequestClose={handleCloseModal}
            contentLabel=""
            appElement={document.getElementById('root')}
            ef={c => this.modal = c}>
            <div className={"modal-window"}>
                <img alt='close' src={closeButton} className='popUp-close-bot' type='button' onClick={hideModal}/>
                {modalData}
            </div>
        </Modal>
    );
}

ModalComponent.propTypes = {
    data: PropTypes.any,
    className: PropTypes.string,
    modalIsOpen: PropTypes.bool,
    handleCloseModal: PropTypes.func,
    hideModal: PropTypes.func,
};

export default ModalComponent;
